module.exports = __webpack_public_path__ + "static/media/gilroy-semibold.ac29a758.otf";